import { render, staticRenderFns } from "./CDTopLanguages.vue?vue&type=template&id=43a08875&scoped=true"
import script from "./CDTopLanguages.vue?vue&type=script&lang=ts"
export * from "./CDTopLanguages.vue?vue&type=script&lang=ts"
import style0 from "./CDTopLanguages.vue?vue&type=style&index=0&id=43a08875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a08875",
  null
  
)

export default component.exports